import React from 'react'
import './Divider.scss'

const Divider = ({ orientation = 'horizontal', className }) => {
  const cls = ['divider', `divider--${orientation}`, className].filter(Boolean).join(' ')
  return <div role="separator" aria-orientation={orientation} className={cls} />
}

export default Divider
